module.exports = __webpack_public_path__ + "static/media/2_portrait.911e3afb.jpg";